import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const Headline = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'relative',
        '&::after': {
          position: 'absolute',
          content: '""',
          width: '30%',
          zIndex: 1,
          top: 0,
          right: 0,
          height: '100%',
          backgroundSize: '18px 18px',
          backgroundImage: `radial-gradient(${alpha(
            theme.palette.primary.dark,
            0.4,
          )} 20%, transparent 20%)`,
          opacity: 0.2,
        },
      }}
    >
      <Box position="relative" zIndex={2}>
        <Typography
          fontWeight={600}
          variant={'h2'}
          gutterBottom
          align={'center'}
        >
          About us
        </Typography>
        <Typography
          variant="h6"
          color={'text.secondary'}
          align={'center'}
          gutterBottom
        >
        </Typography>
        <Typography variant="h6" color={'text.secondary'} align={'center'}>
          Our team consists of highly experienced educators, career coaches, and student advisors who work together to offer a wide range of services tailored to meet the unique needs of each student. From exam preparation and subject-specific tutoring to helping you navigate scholarship opportunities and internships, we are here to help you unlock your potential.
        </Typography>
      </Box>
    </Box>
  );
};

export default Headline;
